import "core-js/modules/es.array.map.js";
import { useQueryLoading } from '@vue/apollo-composable';
import { useGetImpactSdgsForVenturesQuery } from '~/types/types';
export default defineComponent({
  props: {
    impactGoalAssessments: {
      type: Array,
      required: true
    }
  },
  setup: function setup(props) {
    var impactGoalAssessmentIds = computed(function () {
      return props.impactGoalAssessments.map(function (e) {
        return e.ventureId;
      });
    });
    var _useGetImpactSdgsForV = useGetImpactSdgsForVenturesQuery({
        ventureIds: impactGoalAssessmentIds
      }),
      sdgsResult = _useGetImpactSdgsForV.result;
    var sdgAggregations = computed(function () {
      var _sdgsResult$value$get, _sdgsResult$value;
      return (_sdgsResult$value$get = (_sdgsResult$value = sdgsResult.value) === null || _sdgsResult$value === void 0 ? void 0 : _sdgsResult$value.getImpactSdgsForVentures) !== null && _sdgsResult$value$get !== void 0 ? _sdgsResult$value$get : [];
    });
    var loading = useQueryLoading();
    return {
      sdgAggregations: sdgAggregations,
      loading: loading
    };
  }
});